export function isEmailSending(state) {
    const isSending = state.home.get('sendEmailPending');
    console.log('isSending', isSending)
    return isSending;
}

export function isEmailSent(state) {
    const sendSuccess = state.home.get('sendEmailSuccess');
    return sendSuccess;
}


export function resetEmail(state) {
    console.log("reseting email sending")
    state.home.set('sendEmailSuccess', false);
    return;
}


// WEBPACK FOOTER //
// ./src/features/home/redux/selectors.js